/**
 * Assignment utility functions
 */

/**
 * Normalize assignment status to a consistent form for analytics checks.
 * Supports both legacy and current status values (e.g., in_progress -> in-progress).
 * @param {string|undefined|null} status
 * @returns {string}
 */
export const normalizeStatus = (status) => {
  if (!status) return '';
  return String(status).trim().toLowerCase().replace(/_/g, '-');
};

export const isCompletedStatus = (status) => normalizeStatus(status) === 'completed';
export const isInProgressStatus = (status) => normalizeStatus(status) === 'in-progress';
export const isPendingStatus = (status) => normalizeStatus(status) === 'pending';
export const isOverdueStatus = (status) => normalizeStatus(status) === 'overdue';

/**
 * Apply overdue status to assignments based on due dates
 * @param {Array} assignmentsList - Array of assignment objects
 * @returns {Array} Assignments with overdue status applied
 */
export const applyOverdueStatus = (assignmentsList) => {
  const now = new Date();
  return assignmentsList.map(assignment => {
    // If assignment is not completed and due date has passed, mark as overdue
    if (!isCompletedStatus(assignment.status) && assignment.due_date) {
      const dueDate = new Date(assignment.due_date);
      if (dueDate < now) {
        return { ...assignment, status: 'overdue' };
      }
    }
    return assignment;
  });
};